"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModeTreeStateVectorSerializedSchema = void 0;
const zod_1 = require("zod");
const ComponentFunctionStatesSerialized_1 = require("./ComponentFunctionStatesSerialized");
const ISerializedBoundaryConfiguration_1 = require("./ISerializedBoundaryConfiguration");
const SerializedModeState_1 = require("./SerializedModeState");
exports.IModeTreeStateVectorSerializedSchema = zod_1.default.object({
    modeStates: zod_1.default.record(zod_1.default.string(), SerializedModeState_1.SerializedModeStateSchema),
    componentFunctionStates: zod_1.default.lazy(() => ComponentFunctionStatesSerialized_1.SerializedComponentFunctionsMapSchema),
    initialBoundaryMap: zod_1.default
        .lazy(() => ISerializedBoundaryConfiguration_1.ISerializedBoundaryConfigurationSchema)
        .array()
        .optional(),
});
//# sourceMappingURL=IModeTreeStateVectorSerialized.js.map